export class Deferred<T = void> {
  private _promise: Promise<T>;
  private _resolve: (data: T | PromiseLike<T>) => void;
  private _reject: (reason?: unknown) => void;

  constructor() {
    this._promise = new Promise<T>((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  get promise(): Promise<T> {
    return this._promise;
  }

  get resolve(): (data: T | PromiseLike<T>) => void {
    return this._resolve;
  }

  get reject(): (reason?: unknown) => void {
    return this._reject;
  }
}
